export const initialState = {
  tasks: [],
  tasksLoading: false,
  tasksTotalPages: 1,
  tasksCurrentPage: 1,
  tasksTotal: 0,

  taskStats: null,
  taskStatsLoading: false,
  windowCounts: null,
  viewCounts: null,

  createTaskLoading: false,

  currentTask: null,
  currentTaskLoading: false,

  projects: [],
  projectsLoading: false,

  teams: [],
  teamsLoading: false,

  formTemplates: [],
  formTemplatesLoading: false,

  currentFormTemplate: null,
  currentFormTemplateLoading: false,
  formTemplateSaving: false,
  formResponseSaving: false,
  approverFormSaving: false,
  formVersions: [],
  formVersionsLoading: false,
  conflicts: [],
  conflictsLoading: false,
  taskActionLoading: false,

  filters: {
    status: 'all',
    category: null,
    window: null,
    type: null,
    origin: null,
    assignedTo: null,
    approverId: null,
    open: false,
    buildingId: null,
    projectId: null,
    search: '',
    priority: null,
    formTemplateId: null,
    teamId: null,
    deadlineFrom: null,
    deadlineTo: null,
    createdFrom: null,
    createdTo: null
  },

  templateAssignments: [],
  templateAssignmentsLoading: false,

  selectedTaskIds: [],
  bulkActionLoading: false,

  taskSettings: null,
  taskSettingsLoading: false,

  projectDashboard: null,
  projectDashboardLoading: false
}
